import React from 'react';

const EditPersonalInfoScreen = () => {
	return <div>EDIT PERSONAL INFO</div>;
};

export default EditPersonalInfoScreen;
